import { action, observable } from 'mobx';

import { OTP_FLOW } from '~constants/Constants';

import { OtpStore } from './OtpStore';
import { RampFormStore } from './RampFormStore';

interface ISignInWithOtpFormStore {
    otpStore: OtpStore;
}

export interface ISignInWithOtpFormValues {
    emailAddress: string;
    password: string;
}

export enum View {
    PASSWORD = 'password',
    EMAIL = 'email'
}

export class SignInWithOtpFormStore extends RampFormStore<ISignInWithOtpFormValues> {
    @observable public view?: View;
    @observable public isResetPassword = false;
    @observable public isSignInWithOtp = false;
    @observable public otpStore: OtpStore;

    constructor({ otpStore }: ISignInWithOtpFormStore) {
        super({
            emailAddress: '',
            password: ''
        });

        this.otpStore = otpStore;
    }

    public setEmailAddress = (emailAddress: string) => {
        this.setFieldValue('emailAddress', emailAddress);
    };

    @action
    public setView = (view?: View) => {
        this.view = view;
    };

    public setOtpFlow = (flow: OTP_FLOW) => {
        this.otpStore.setData({ flow });
    };
}
